export enum TopLevelLink {
	Admin = 'admin',
	Dashboard = 'dashboard',
}

export enum NavItemId {
	Locations = 'locations-nav-item',
	Team = 'team-nav-item',
	ProductsAndServices = 'products-and-services-nav-item',
	Tasks = 'tasks-nav-item',
	Promotions = 'promotions-nav-item',
	Account = 'account-nav-item',
	Dashboards = 'dashboards-nav-item',
	Dispatch = 'dispatch-nav-item',
	Orders = 'orders-nav-item',
	Customers = 'customers-nav-item',
	EQUIPMENT = 'machines-nav-item',
	Reports = 'reports-nav-item',
	Marketing = 'marketing-nav-item',
	Messages = 'messages-nav-item',
	CallCenter = 'call-center-nav-item',
	Notifications = 'notifications-nav-item',
	AssistSettings = 'assist-settings-nav-item',
	AssistSettingsStores = 'assist-settings-stores-nav-item',
	NOTIFICATION_TEMPLATES = 'notification-templates-nav-item',
	INTEGRATIONS = 'integrations-nav-item',
	POPUP_EVENTS = 'popup-events-nav-item',
	ACCELERATE_REGISTRATION = 'accelerate-registration-nav-item',
}

export type NavItemLink = {
	title: string;
	tooltipTitle?: string;
	pathname: string;
	icon?: JSX.Element;
	className?: string;
	handleClick?: () => void;
	count?: number;
	showNewLabel?: boolean;
	showBetaLabel?: boolean;
	tag?: string;
};

export type NavItemButton = {
	title: string;
	onClick: () => void;
	icon?: JSX.Element;
};

export type NavItemEmpty = {
	isEmpty: true;
	pathname: string;
};

export type NavItem = {
	id: NavItemId;
	title: string;
	icon: JSX.Element;
	pathname?: string;
	showNewLabel?: boolean;
	/** The store does not own this surface; the item leads to its upsell (COS-4843). */
	showUpsellLabel?: boolean;
};

export type NavItemWithDropdown = {
	title: string;
	dropdownItems: NavItemLink[];
	dropdownFooter?: NavItemButton;
	searchPlaceholder?: string;
	emptyText?: string;
};

export type CategorizedLink = {
	label?: string;
	isEmpty?: boolean;
	links: (
		| NavItemLink
		| NavItemButton
		| NavItemEmpty
		| NavItemWithLinks
		| NavItemWithDropdown
	)[];
	innerProps?: Record<string, unknown>;
	sortable?: boolean;
};

export type NavItemWithLinks = {
	id: NavItemId;
	title: string;
	icon: JSX.Element;
	links: CategorizedLink[];
	className?: string;
	handleClick?: () => void;
};
